const order = {
  state: {
    goodsId: '',
    goodsType: '',
    content: '',
    desc: '',
    name: '',
    price: '',
    priceLabel: '',
    account: '', // 用于显示的实际要支付的金额
    discountList: [], // 优惠信息
    discountDetail: {
      discountTotalPrice: 0, // 优惠总价
      discountTotalPriceLabel: '',
      discountedPrice: 0, // 折后价
    }, // 折扣相关
    shareId: '',
  },
  mutations: {
    SET_GOODSID: (state, goodsId) => {
      state.goodsId = goodsId
    },
    SET_GOODSTYPE: (state, goodsType) => {
      state.goodsType = goodsType
    },
    SET_CONTENT: (state, content) => {
      state.content = content
    },
    SET_DESC: (state, desc) => {
      state.desc = desc
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_PRICE: (state, price) => {
      state.price = price
    },
    SET_PRICELABEL: (state, priceLabel) => {
      state.priceLabel = priceLabel
    },
    SET_SHAREID: (state, shareId) => {
      state.shareId = shareId
    },
    SET_ACCOUNT: (state, account) => {
      state.account = account
    },
    SET_DISCOUNTDETAIL: (state, discountDetail) => {
      state.discountDetail = discountDetail
    },
    SET_DISCOUNTLIST: (state, discountList) => {
      state.discountList = discountList
    },
  },
  actions: {
    setOrderInfo({ commit }, {
      goodsId = '',
      goodsType = '',
      content = '',
      desc = '',
      name = '',
      price = '',
      priceLabel = '',
      shareId = '',
      account = '',
      discountDetail = {},
      discountList = [],
      } = {}) {
      commit('SET_GOODSID', goodsId)
      commit('SET_GOODSTYPE', goodsType)
      commit('SET_CONTENT', content)
      commit('SET_DESC', desc)
      commit('SET_NAME', name)
      commit('SET_PRICE', price)
      commit('SET_PRICELABEL', priceLabel)
      commit('SET_SHAREID', shareId)
      commit('SET_ACCOUNT', account)
      commit('SET_DISCOUNTDETAIL', discountDetail)
      commit('SET_DISCOUNTLIST', discountList)
    },
    clearOrderInfo({ commit }) {
      commit('SET_GOODSID', '')
      commit('SET_GOODSTYPE', '')
      commit('SET_CONTENT', '')
      commit('SET_DESC', '')
      commit('SET_NAME', '')
      commit('SET_PRICE', '')
      commit('SET_PRICELABEL', '')
      commit('SET_SHAREID', '')
      commit('SET_ACCOUNT', '')
      commit('SET_DISCOUNTDETAIL', '')
      commit('SET_DISCOUNTLIST', '')
    }
  }
}

export default order
